<template>
  <div style="padding: 0 16px 16px;">
    <div style="display: flex; justify-content: space-between;align-items: center;">
      <span style="font-weight: bold;">历史记录</span>
      <el-button type="primary" @click="add">添加</el-button>
    </div>
    <div v-if="pageDataList.length > 0">
      <div v-for="(item,index) in pageDataList" :key="index" style="margin: 20px 0;">
        <span>{{item.createTime}}</span>
        <el-tag style="margin: 0 10px;">{{item.name}}</el-tag>
        <span>{{item.content}}</span>
      </div>
    </div>
    <el-empty v-else description="没有记录"></el-empty>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '../../api/api';
import { getUserSmallRemark } from '../../api/url';
import Dialog from '../../assets/js/dialog'
import AddUserRemarkDialog from './AddUserRemarkDialog'
export default {
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pagesize: 20,
      currentPage: 1,
    }
  },
  methods: {
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      let param = {
        'userId': this.id,
        'pageNum': this.currentPage
      }
      getFormData(getUserSmallRemark, param).then((data) => {
        if(data.code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pagesize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userRemark', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userRemark', JSON.stringify(this.pageDataList));
          }
        }
      })
    },

    add() {
      Dialog.open({
        title: '',
        component: AddUserRemarkDialog,
        data: {
          id: this.id
        },
        confirm: (result) => {
          this.getPage();
        }
      })
    }
  },
  mounted() {
    sessionStorage.removeItem('userLog');
    this.getPage();
  }
}
</script>

<style>

</style>
